/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserDto } from '../../models/center-user-dto';

export interface NonMemberControllerFindTeacherByChildId$Params {
  childId: string;
}

export function nonMemberControllerFindTeacherByChildId(http: HttpClient, rootUrl: string, params: NonMemberControllerFindTeacherByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserDto>>> {
  const rb = new RequestBuilder(rootUrl, nonMemberControllerFindTeacherByChildId.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterUserDto>>;
    })
  );
}

nonMemberControllerFindTeacherByChildId.PATH = '/api/non-member/teacher';
